import { useState } from 'react';
import { frankfurtDetailPhotos } from '@/mocks/frankfurt2026';
import PhotoLightbox from './PhotoLightbox';

export default function BoothCollage() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {frankfurtDetailPhotos.map((photo, index) => (
          <button
            key={photo.src}
            type="button"
            onClick={() => setOpenIndex(index)}
            className="group relative block aspect-[4/3] overflow-hidden rounded-xl border border-white/10 cursor-pointer text-left"
            aria-label={`Open close-up ${index + 1}: ${photo.caption}`}
          >
            <img
              src={photo.src}
              alt={photo.caption}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/90 via-navy-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-4">
              <span className="text-[10px] font-semibold text-gold-300 uppercase tracking-[0.16em] mb-1">
                {photo.tag}
              </span>
              <p className="text-[11px] text-white/90 leading-snug line-clamp-2">{photo.caption}</p>
            </div>
            <div className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-navy-950/55 backdrop-blur-sm text-[10px] font-medium text-white/85">
              {String(index + 1).padStart(2, '0')}
            </div>
          </button>
        ))}
      </div>

      <div className="mt-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="text-xs text-cream-200/60 flex items-center gap-2">
          <i className="ri-cursor-line text-gold-400"></i>
          Click any frame to open it, then use the arrow keys to move through the set.
        </p>
        <button
          type="button"
          onClick={() => setOpenIndex(0)}
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-xs font-semibold text-navy-900 bg-gold-400 rounded-full hover:bg-gold-300 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-slideshow-line"></i>
          Start the close-up tour
        </button>
      </div>

      <PhotoLightbox photos={frankfurtDetailPhotos} openIndex={openIndex} onClose={() => setOpenIndex(null)} />
    </>
  );
}